import IpubButton from './src/main';

/* istanbul ignore next */
IpubButton.install = function(Vue) {
  Vue.component(IpubButton.name, IpubButton);
};

export default IpubButton;
